export const environment = {
  production: true,
  splixerUrl: 'https://player-api.splixer.com/player_api/v3/',
  //splixerUrl: 'https://player-api.tkatlabs.com/player_api/v3/',
  defaultStationCode: 'a443b585-82b7-4101-b36e-97f5366e4a30',
  defaultGaTrackingId: '',
};
